export default __webpack_public_path__ + "static/media/news96.4d5d56b7.jpg";